import { useState } from 'react'
import * as Dialog from '@radix-ui/react-dialog'
import { PencilEdit01Icon } from '@hugeicons/core-solid-rounded'
import { useLingui } from '@lingui/react/macro'

import { dialogContainer, DialogHeader } from '@/layouts/Dialog'
import Button from '@/components/ui/Button'
import { BannersFormSuspended } from './BannersForm'

export function EditBanners() {
  const { t } = useLingui()
  const [open, setOpen] = useState(false)

  return (
    <Dialog.Root open={open} onOpenChange={setOpen}>
      <Dialog.Trigger asChild>
        <Button Icon={PencilEdit01Icon} />
      </Dialog.Trigger>
      <Dialog.Portal container={dialogContainer}>
        <Dialog.Overlay className="fixed size-full inset-0 bg-black/30 grid place-items-center overflow-y-auto z-top-dialog">
          <Dialog.Content className="relative w-screen max-w-[700px] py-10 px-2">
            <div className="shadow-md rounded bg-white flex flex-col gap-4 p-5">
              <DialogHeader
                title={t`Edit Banners`}
                description={t`Here you can add new banners or edit your existing ones.`}
                close={() => setOpen(false)}
              />
              <BannersFormSuspended />
            </div>
          </Dialog.Content>
        </Dialog.Overlay>
      </Dialog.Portal>
    </Dialog.Root>
  )
}
